module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "invite",
    on: {
      "submit": _vm.prevent
    }
  }, [(_vm.$slots.inputs) ? _c('div', {
    staticClass: "invite__inputs"
  }, [_vm._t("inputs")], 2) : _vm._e(), _c('div', {
    staticClass: "invite__buttons"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-056f5400","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/invite/form/InviteForm.vue
// module id = ed496628e1af5aa9e9d8
// module chunks = 22